import moment from 'moment';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import { useValidationErrorHandle } from '../functions/validationErrorHandle';
import { useRef } from 'react';
// const format = 'h:mm a';
export const ReactTimePicker = (props) => {
  const validationErrorHandle = useValidationErrorHandle()
const str = props?.showSecond===true ? 'HH:mm:ss' : 'HH:mm';

function onChange(value) {
  if(!value){
    return
  }
  const formatValue =  value?.format(str) ? value?.format(str)  : null  
if (formatValue !== null) {
  props?.onChange?.(formatValue);
}
}


// const disabledHours = () => {
//     // Disable hours from 0 (midnight) to 8 AM, and from 22 (10 PM) to 23 (11 PM)
//     return [0, 1, 2, 3, 4, 5, 6, 7, 8, 22, 23];
//   };


  return (
    <div className={props?.InputDivClass}>
         {props.label ? (
          <label className={` ${props.labelClass} text-normal `}>
            {props.label}
          </label>
        ) : (
          ''
        )
        }
    <TimePicker
    id={props?.id}
    disabledHours={props?.disabledHours}
    disabledMinutes={props?.disabledMinutes}
    disabled={props?.disable}
    showSecond={props?.showSecond===true ? props?.showSecond : false }
    value={moment(props?.value || '12:00', 'HH:mm')}
    className={`${props?.className} block w-full sm:text-sm md:text-md text-gray-700 
                        focus:border-sky-200 focus:ring-sky-200 focus:outline-none focus:ring focus:ring-opacity-40`} 
    onChange={onChange}
    format={props?.format}
    allowEmpty={false}
    use12Hours
    // hideDisabledOptions
  />
           {props.error ? (
            <p className='mt-1 text-red-400 md:text-sm sm:text-[.65rem]'>{validationErrorHandle(props.error)}</p>
          ) : (
            ''
          )}
  </div>
  )
};
ReactTimePicker.defaultProps = {
    InputDivClass:'mt-10',
    labelClass: 'mt-2 text-gray-700 text-sm',
    className:'block',
    disabledHours: undefined,
    disabledMinutes: undefined
  }
